<template>
  <el-form label-width="80px" class="form">
    <el-row>
      <el-col :span="6">
        <el-form-item :label="$t('track.trackName')">
          <el-input :placeholder="$t('track.trackNamePlaceholder')" clearable v-model="form.track_name"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item :label="$t('common.singerName')">
          <el-input :placeholder="$t('common.singerNamePlaceholder')" clearable v-model="form.singer_name"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item :label="$t('album.albumName')">
          <el-input :placeholder="$t('album.albumNamePlaceholder')" clearable v-model="form.album_name"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="ISRC">
          <el-input :placeholder="$t('track.isrcPlaceholder')" clearable v-model.trim="form.isrc"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item :label="$t('common.publicTime')">
          <el-date-picker
            class="form-field"
            v-model="form.public_time"
            clearable
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('common.publicTimePlaceholder')"
            @change="handleSearch"
          ></el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item :label="$t('common.relateCompany')">
          <el-select
            class="form-field"
            v-model="form.company_id"
            @change="handleSearch"
            clearable
          >
            <el-option v-for="{ id, name } of companyList" :key="id" :label="name" :value="id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item :label="$t('data.apply.platform')">
          <el-select
            class="form-field"
            v-model="form.platform"
            clearable
            @change="handleSearch"
          >
            <el-option v-for="[id] of platformMap" :key="id" :label="$t(`data.apply.platformMap.${id}`)" :value="id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <slot />
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { languageMap, platformMap, cycleMap, sortMap } from '../../mixin'
import dataService from '@/api/data'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export default {
  name: 'SearchForm',

  data() {
    return {
      form: {
        track_name: '',
        album_name: '',
        singer_name: '',
        isrc: '',
        public_time: '',
        company_id: '',
        platform: 'tme',
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      loading: false,
      tableData: [],
      companyList: [],
      languageMap,
      platformMap,
      cycleMap,
      sortMap,
      isYxCompany: true,
      ROLE_TYPE_ENUM
    }
  },

  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },

  mounted() {
    this.fetchCompanyList()
  },

  methods: {
    handleSearch() {
      this.$emit('search')
    },
    async fetchCompanyList() {
      try {
        const res = await dataService.getCompanyList()
        this.companyList = res.list
        this.handleSearch()
      } catch (e) {
        this.$message.error('获取厂牌数据异常：' + e.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-field {
  width: 100%;
}

.form .el-form-item {
  margin-bottom: 8px !important;
}
</style>
